export default {
  getMonitorings(state) {
    return state.monitorings;
  },
  getCurrentMonitoring(state) {
    return state.currentMonitoring;
  },
};
